(function () {
  var HOL = ['01-01', '01-06', '05-01', '08-15', '10-12', '11-01', '12-06', '12-08', '12-25'];
  function madrid() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Madrid' })); }
  function isBiz(d) {
    var w = d.getDay();
    if (w === 0 || w === 6) return false;
    var k = ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    return HOL.indexOf(k) < 0;
  }
  function cutoffText() {
    var n = madrid();
    if (isBiz(n) && n.getHours() < 14) {
      var end = new Date(n); end.setHours(14, 0, 0, 0);
      var s = Math.max(0, Math.floor((end - n) / 1000));
      var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60);
      return '<strong>Pídelo en las próximas ' + (h ? h + ' h ' : '') + m + ' min</strong> y lo tramitamos hoy.';
    }
    return '<strong>Pídelo ahora</strong> y lo tramitamos el próximo día laborable.';
  }
  function getD() { try { var d = parseFloat(localStorage.getItem('vh_diopter')); return isNaN(d) ? null : d; } catch (e) { return null; } }

  function boot() {
    var root = document.querySelector('[data-vp-root]');
    if (root) {
      var lines = root.querySelector('.vp__lines');
      if (lines) {
        var li = document.createElement('li');
        li.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M12 7v5l3 2"/><circle cx="12" cy="12" r="9"/></svg><span data-vh-cutoff></span>';
        lines.insertBefore(li, lines.firstChild);
        var el = li.querySelector('[data-vh-cutoff]');
        el.innerHTML = cutoffText();
        setInterval(function () { el.innerHTML = cutoffText(); }, 30000);
      }
      var d = getD();
      var gi = parseInt(root.dataset.gradIndex, 10);
      if (d !== null && gi >= 0) {
        var fs = root.querySelector('[data-option-index="' + gi + '"]');
        if (fs) {
          var inputs = Array.prototype.slice.call(fs.querySelectorAll('input'));
          var m = inputs.filter(function (i) {
            var n = parseFloat(String(i.value).replace('+', '').replace(',', '.'));
            return !isNaN(n) && Math.abs(n - d) < 0.001;
          })[0];
          if (m && !m.closest('.vp__pill').classList.contains('is-unavailable')) {
            if (!m.checked) { m.checked = true; m.dispatchEvent(new Event('change', { bubbles: true })); }
            var note = document.createElement('p');
            note.style.cssText = 'margin:-.4rem 0 1.6rem;font-size:1.3rem;color:#6b6b6b';
            note.textContent = 'Preseleccionada según tu test de graduación. Puedes cambiarla.';
            fs.parentNode.insertBefore(note, fs.nextSibling);
          }
        }
      }
    }
  }
  if (document.readyState === 'complete') setTimeout(boot, 50); else window.addEventListener('load', function () { setTimeout(boot, 50); });
})();